
import { useState, useEffect } from 'react';
import Header from '../../home/components/Header';
import Footer from '../../home/components/Footer';

export default function AboutPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header scrolled={scrolled} />
      <main className="pt-24 pb-20">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
          <h1 className="text-4xl md:text-5xl font-bold text-center mb-20 tracking-tight">
            COMPANY PROFILE
          </h1>

          <div className="space-y-0">
            <div className="border-t border-gray-200 py-8 grid md:grid-cols-[200px_1fr] gap-6">
              <div className="text-sm font-medium text-gray-600">会社名</div>
              <div className="text-base text-gray-900">ワンダークラフトカンパニー株式会社</div>
            </div>

            <div className="border-t border-gray-200 py-8 grid md:grid-cols-[200px_1fr] gap-6">
              <div className="text-sm font-medium text-gray-600">設立</div>
              <div className="text-base text-gray-900">2026年1月</div>
            </div>

            <div className="border-t border-gray-200 py-8 grid md:grid-cols-[200px_1fr] gap-6">
              <div className="text-sm font-medium text-gray-600">本社</div>
              <div className="text-base text-gray-900">〒150-0012 東京都渋谷区広尾1-2-1 ヒカリビル4F</div>
            </div>

            <div className="border-t border-gray-200 py-8 grid md:grid-cols-[200px_1fr] gap-6">
              <div className="text-sm font-medium text-gray-600">取引銀行</div>
              <div className="text-base text-gray-900">三井住友銀行</div>
            </div>

            <div className="border-t border-b border-gray-200 py-8 grid md:grid-cols-[200px_1fr] gap-6">
              <div className="text-sm font-medium text-gray-600">事業概要</div>
              <div className="text-base text-gray-900">
                インターネットビジネスの企画・開発・運営・各種コンサルティング、開発・実装、運用・実行の提供
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
